import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

import { NAME_BY_DIRECTION_SHORT } from './translations'

import styles from './Direction.scss'

const Direction = (props) => {
    const bonusNode = !props.bonus ? null : (
        <div className={styles.bonus}>{'x2'}</div>
    )
    const battleNode = !props.battle ? null : (
        <div className={styles.battle} />
    )
    const modifierComponent = battleNode || bonusNode

    const className = classNames(styles.base, {
        [styles.base__bonus]: props.bonus,
        [styles.base__battle]: props.battle,
    })

    const tooltipProps = (props.tooltipId) ? {
        'data-tip': true,
        'data-for': props.tooltipId,
    } : null

    return (
        <div className={className} {...tooltipProps}>
            {modifierComponent}
            <div className={styles.icon}>
                <span className={styles.shortName}>{NAME_BY_DIRECTION_SHORT[props.direction]}</span>
            </div>
        </div>
    )
}

Direction.propTypes = {
    direction: PropTypes.string.isRequired,
    bonus: PropTypes.bool,
    battle: PropTypes.bool,
    tooltipId: PropTypes.string,
}

export default Direction



// WEBPACK FOOTER //
// ./components/BattleWizard/components/Direction/Direction.jsx